import React from 'react';
import { CaseStudy } from '../../types/case-study';
import Container from '../container';
import RichtextParser from '../../utils/richtext-parser';
import Button from '../button';
import parseStoryblokLink from '../../utils/parseStoryblokLink';
import styled, { css } from 'styled-components';
import CaseStudySquareCard from './CaseStudySquareCard';
import mq from '../../utils/mq';
import { styledLink } from '../../utils/styles';

const OuterContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 96px 0;
  background: var(--Background-bg-inverse, #111);
  ${mq.mobile(css`
    padding: 64px 0;
  `)};
`;

const TitleSection = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 44px;
  padding-bottom: 38px;
  @media (max-width: 1000px) {
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
    gap: 12px;
  }
`;

const Title = styled.h2`
  color: #fff;
  font-size: 42px;
  font-style: normal;
  font-weight: 700;
  line-height: 115%;
  max-width: 536px;
  @media (max-width: 1000px) {
    max-width: unset;
  }
  &.light-theme {
    color: #161616;
  }
  ${mq.mobile(css`
    font-size: 36px;
  `)};
`;

const Description = styled.div`
  color: var(--Grey-9, #fafafa);
  font-size: 16px;
  font-weight: 400;
  line-height: 160%;
  letter-spacing: 0;
  max-width: 536px;
  @media (max-width: 1000px) {
    max-width: unset;
  }
  p,
  span {
    color: #fff !important;
  }
  a {
    ${styledLink};
    text-decoration: none;
  }
  &.light-theme {
    color: #666;
    p,
    span {
      color: #666 !important;
    }
  }
`;

const CardsContainer = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 20px;
  ${mq.tablet(css`
    grid-template-columns: repeat(1, 1fr);
  `)};
  ${mq.mobile(css`
    gap: 32px;
  `)};
`;

const CtaContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding-top: 80px;
  ${mq.mobile(css`
    padding-top: 40px;
    justify-content: flex-start;
    align-items: flex-start;
  `)};
`;

export default function CaseStudySquareCards({
  title,
  description,
  ctaLabel,
  ctaLink,
  caseStudies
}: {
  title: string;
  description: any;
  ctaLabel: string;
  ctaLink: any;
  caseStudies: CaseStudy[];
}) {
  return (
    <OuterContainer>
      <Container>
        <TitleSection>
          <Title>{title}</Title>
          <Description
            dangerouslySetInnerHTML={{ __html: RichtextParser(description) }}
          />
        </TitleSection>
        <CardsContainer>
          {caseStudies &&
            caseStudies?.length > 0 &&
            caseStudies?.map((caseStudy, i) => (
              <CaseStudySquareCard key={i} {...caseStudy} />
            ))}
        </CardsContainer>
        {ctaLabel && ctaLink && (
          <CtaContainer>
            <Button to={`/${parseStoryblokLink(ctaLink)}`} borderColorPrimary>
              {ctaLabel}
            </Button>
          </CtaContainer>
        )}
      </Container>
    </OuterContainer>
  );
}
